<script>
import Chart from "chart.js";
import { generateChart, mixins as barChartMixins } from "vue-chartjs";

const { reactiveProp } = barChartMixins;

Chart.defaults.imageBarChart = Chart.defaults.bar;

Chart.controllers.imageBarChart = Chart.controllers.bar.extend({
  async draw() {
    Chart.controllers.bar.prototype.draw.apply(this, arguments);

    const meta = this.getMeta();

    for (let data of meta.data) {
      const { x, y, label: lbl } = data._view;
      const imgSize = data._xScale.options.barThickness;
      const ctx = this.chart.chart.ctx;
      const img = await lbl.logoImg;

      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.drawImage(img, x - (imgSize / 2), y - imgSize - 2, imgSize, imgSize);
      ctx.restore();
    }
  }
});

const ImageBarChart = generateChart('image-bar-chart', 'imageBarChart');

export default {
  extends: ImageBarChart,

  name: "ImageBarChart",

  mixins: [ reactiveProp ],

  props: {
    options: {
      type: Object
    },
  },

  mounted() {
    this.addPlugin({
      beforeInit(chart) {
        chart.legend.afterFit = function() {
          this.height = this.height + 25;
        }
      }
    });

    this.$nextTick(() => {
      this.renderChart(this.chartData, this.options);
    });
  }
}
</script>